import { ILinkedEmail, ILinkedPhone, ILinkedUrl } from "./contacts";

export class UserContactsDto {
  linkedPhones: ILinkedPhone[];
  linkedEmails: ILinkedEmail[];
  linkedUrls: ILinkedUrl[];
}

